/*
		Widget UX
*/


function activateUI(e) {
	console.log('widgetUX init');
	var widget = e;
	console.log(e.idDiv);

	// step 2 : montant des travaux
	$( "#simu__step-2__slider" ).slider({

		min: 0,
		max: 100,
		slide: function( event, ui ){
			$('#'+ e.idDiv +'-'+'montant_travaux').val(coeffTravaux(ui.value));
			$(".simu__slider__progress", this).width(ui.value + "%");
			// console.log(coeffTravaux(ui.value));
		},
		change: function (event, ui ) {
			$('#'+ e.idDiv +'-'+'montant_travaux').val(coeffTravaux(ui.value));
			$('#'+ e.idDiv +'-'+'montant_travaux').change();
			// console.log(coeffTravaux(ui.value));
		}
	});
	$( '#'+ e.idDiv +'-'+'simu__step-2__slider' ).append('<div class="simu__slider__progress"></div>');
	function coeffTravaux(val) {
		return (val * val * 50);
	}

	// $('.widgetsimu__input-container__unit-date input').datepicker(
	// 	$.datepicker.regional[ "fr" ]
	// );

	// séparateur de milier
	$('input.js-montant').change(function() {
		console.log('séparateur de milliers');
		var value = $(this).val().replace(' ', '');
		$(this).val( value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") );
	});

	$('input.valide-phone').change( function() {
		if(!widget.validePhone($(this).val())) {
			$('#'+ e.idDiv +'-'+'simu_step_' + e.currentStep + ' .wg-require', e.widget).text('Le numéro de téléphone saisi n\'est pas valide.').show(300);
		}
	});
	// les anciens boutons en radio
	// pb avec ce code -> erreur dans widgetSimu._gotoStep() ??

	// $('.widgetsimu__radio--button', e.widget).change(function() {
	// 	widget._gotoStep('next');
	// });

	// bootstrap
	// ---------
	// Tooltips
	$('[data-toggle="tooltip"]').tooltip();

	// spécifique à la page du simu
	$('.lpi-simu--footer__ctrl').click(function() {
		$('body').toggleClass('hideNotice');
		$(this).addClass('clicked');
	});
}
